import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Input, InputGroup } from "reactstrap";
import classnames from "classnames";
import MPSBarLoader from "../../components/MPSBarLoader";
import Text from "../../components/Text";
import Messages from "../../Shared/Messages";
import I18nProvider from "../../services/I18nProvider";
import "./LoginMFAOtp.scss";

const intl = I18nProvider.getIntlProvider();
const RESEND_COOLDOWN = 60;

const LoginMFAOtp = ({ loading, loginError, onLoginWithMfa, onResendOtp }) => {
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(RESEND_COOLDOWN);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [resendTimer]);

  const handleResend = useCallback(() => {
    if (canResend && onResendOtp) {
      onResendOtp();
      setResendTimer(RESEND_COOLDOWN);
      setCanResend(false);
    }
  }, [canResend, onResendOtp]);

  const onLogin = (e) => {
    e.preventDefault();
    onLoginWithMfa(otp);
  };

  const disabled = loading;

  return (
    <form onSubmit={onLogin}>
      <div className="text-center font-lg my-3">
        <Text content={Messages.mfa_enter_otp} />
      </div>
      <InputGroup className="mb-3">
        <Input
          autoFocus={true}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          type="text"
          autoCapitalize="none"
          placeholder={intl.formatMessage(Messages.otp)}
          disabled={disabled}
          className={classnames(loginError ? "is-invalid" : "")}
          id="login-txt-otp"
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            fontSize: 24,
          }}
        />
      </InputGroup>

      <div className="login-mfa-otp__resend">
        {canResend ? (
          <button
            type="button"
            className="login-mfa-otp__resend-button"
            onClick={handleResend}
            disabled={disabled}
          >
            <Text content={Messages.resend_code} />
          </button>
        ) : (
          <span className="login-mfa-otp__resend-timer">
            <Text content={Messages.resend_code_in} data={{ seconds: resendTimer }} />
          </span>
        )}
      </div>

      <Row>
        <Col
          xs="12"
          className="d-flex align-items-center justify-content-end mt-2"
        >
          {loading ? (
            <div
              className="d-flex align-items-center"
              style={{ width: 75, height: 37 }}
            >
              <MPSBarLoader width={75} />
            </div>
          ) : (
            <Button
              color="primary"
              className="px-4"
              disabled={disabled}
              id="login-btn-submit"
              style={{
                width: "100%",
                padding: "0.5rem 0.75rem",
                fontWeight: 600,
              }}
            >
              <Text content={Messages.submit} />
            </Button>
          )}
        </Col>
      </Row>
    </form>
  );
};

export default LoginMFAOtp;
